import React, { useEffect, useState } from 'react'
import { PlusOutlined, SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { Button, Input, Modal, message, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { SearchWrapper } from '../DataSource/dataSource.styled'
import useParams from '../../hook/useParams'
import { WhiteWrapper } from './group.styled'
import MainTable from '../../components/Basic/MainTable'
import dayjs from 'dayjs'
import { deleteGroup, fetchGroupList } from '../../apis/group'
import GroupModal from './modals/GroupModal'
import { fetchFunctions } from '../../apis/auth'
import { useNavigate } from 'react-router-dom'

function GroupList (props) {
  const { setNowTab, setGroup, setBrand } = props
  const { t: ln_t } = useTranslation()
  const params = useParams()
  const { handleFetchParams, fetchParams } = params
  const navigate = useNavigate()

  const [showModal, setShowModal] = useState(false)
  const [modalData, setModalData] = useState({})
  const [menus, setMenus] = useState([])

  const handleRedirect = record => {
    setNowTab('user')
    setGroup(record?.id)
    setBrand()
  }

  const handleAdd = () => {
    setModalData({ addMode: true })
    setShowModal(true)
  }
  const handleEdit = record => {
    setModalData(record)
    setShowModal(true)
  }
  const handleDelete = record => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t('group.group')}`,
      content: `${ln_t('message.confirm.delete')} ${record.name}?`,
      onOk: async () => {
        const result = await deleteGroup(record?.id)
        if (result?.status === 204) {
          handleFetchParams('add', {})
          message.success(ln_t('message.success.delete'))
        }
      }
    })
  }

  const handleManage = (record, mode) => {
    switch (mode) {
      case 'site':
        navigate('/admin/account/site', { state: { record } })
        break
      case 'track':
        navigate('/admin/account/track', { state: { record } })
        break
      default:
        break
    }
  }

  const apiFunc = async () => fetchGroupList(fetchParams)
  const formatDate = (data, detail) => dayjs(data).format(`YYYY-MM-DD${detail ? ' hh:mm:ss' : ''}`)
  const columns = [
    {
      title: ln_t('group.name'),
      dataIndex: 'name',
      render: (name, record) => <div style={{ color: 'var(--primary', cursor: 'pointer' }} onClick={() => handleRedirect(record)}>{name}</div>
    },
    { title: ln_t('group.segmentLimit'), dataIndex: 'limits', sorter: true, render: e => e?.segmentLimit || ln_t('util.notSettingYet') },
    { title: ln_t('group.targetingLimit'), dataIndex: 'limits', sorter: true, render: e => e?.targetingLimit || ln_t('util.notSettingYet') },
    { title: ln_t('group.status'), dataIndex: 'status', sorter: true, render: e => e ? ln_t('util.enable') : ln_t('util.disable') },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', sorter: true, render: e => formatDate(e) },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', sorter: true, render: e => formatDate(e, true) },
    {
      title: ln_t('util.actions'),
      dataIndex: 'id',
      render: (e, record) => {
        const source = record?.dataSourceTypes?.split(',')
        return (
          <div className="item-funcs" style={{ gap: '15px' }}>
              {source?.includes('1')
                ? (
                  <Tooltip title="Site管理">
                    <span style={{ cursor: 'pointer', color: '#046BB4' }} onClick={() => handleManage(record, 'site')}>SITE</span>
                  </Tooltip>
                  )
                : <div style={{ minWidth: '29px' }} />}
              {source?.includes('2')
                ? (
                  <Tooltip title="Track管理">
                    <span style={{ cursor: 'pointer', color: '#BD2323' }} onClick={() => handleManage(record, 'track')}>TRACK</span>
                  </Tooltip>
                  )
                : <div style={{ minWidth: '40px' }} />}

          </div>
        )
      }
    },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, record) => <div className="action-btn">
        <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
        <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
      </div>
    }
  ]

  const successCallback = () => {
    message.success(ln_t('message.success.create'))
    handleFetchParams('add', {})
  }

  const getFunctions = async () => {
    const result = await fetchFunctions({ maxResults: 1000, status: 1, type: 1 })
    if (result?.status === 200) setMenus(result?.data)
  }
  useEffect(() => { getFunctions() }, [])

  return (
    <WhiteWrapper>
      <h3>{ln_t('group.group')}</h3>
      <SearchWrapper>
        <Input.Search
          allowClear
          style={{ width: '400px' }}
          placeholder={ln_t('util.search')}
          onSearch={e => handleFetchParams('add', { name_like: `%${e}%` })}
          enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
        />
        <Button type="default" icon={<PlusOutlined />} onClick={() => handleAdd()}>
          {ln_t('util.add')} {ln_t('group.group')}
        </Button>
      </SearchWrapper>
      <MainTable
        columns={columns}
        rowKey="id"
        apiFunc={apiFunc}
        params={params}
      />
      <GroupModal
        {...props}
        menus={menus}
        show={showModal}
        setShow={setShowModal}
        data={modalData}
        successCallback={successCallback}
      />
    </WhiteWrapper>
  )
}

export default GroupList
